import benefits_1_img from "../../assets/benefits/boje/crvena.png";
import benefits_2_img from "../../assets/benefits/boje/zelena.png";
import benefits_3_img from "../../assets/benefits/boje/zuta.png";
import benefits_4_img from "../../assets/benefits/boje/plava.png";

import num_1 from "../../assets/benefits/nums/num_1_white.svg";
import num_2 from "../../assets/benefits/nums/num_2_white.svg";
import num_3 from "../../assets/benefits/nums/num_3_white.svg";
import num_4 from "../../assets/benefits/nums/num_4_white.svg";

const benefitsImages = [
  { img: benefits_1_img, num: num_1 },
  { img: benefits_2_img, num: num_2 },
  { img: benefits_3_img, num: num_3 },
  { img: benefits_4_img, num: num_4 },
];

export default benefitsImages;